import Axios from 'axios';
import { store } from "../store/store";
import router from '../router';
import {
  Message,
} from 'element-ui';
let gateWayUrl = process.env.VUE_APP_API_DOMAIN;

Axios.defaults.baseURL = gateWayUrl;
Axios.defaults.headers.post['Content-Type'] = "application/x-www-form-urlencoded";
let access_token = sessionStorage.getItem("access_token");
Axios.defaults.headers = {
  'client_id': "system_manage0000000000000000000db327c39298cfa18b2473fc8c489a5d5",
  'Authorization': "Bearer " + access_token
}
/* eslint-disable no-new */
// 添加一个请求拦截器
Axios.interceptors.request.use(function (config) {
  if (sessionStorage.getItem("access_token")) {
    config.headers.Authorization = "Bearer " + sessionStorage.getItem("access_token");
  }
  config.headers['client_id'] = "system_manage0000000000000000000db327c39298cfa18b2473fc8c489a5d5";
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});
// 添加一个响应拦截器
Axios.interceptors.response.use(function (response) {
  // Do something with response data
  if (response.status == 200) {
    switch (response.data.msg) {
      // 请求接口错误
      case "无效token":
        store.commit("getTokenState", false);
        break;
    }
  } else {
    alert('网络错误...请检查！')
  }
  return response;
}, function (error) {
  if (error && error.response && error.response.data && error.response.data.msg)
    Message({
      message: error.response.data.msg,
      type: 'warning',
      duration: 5 * 1000
    })
  if (error.response.status == 401) {
    router.push({
      path: '/login'
    })

  }
  return Promise.reject(error);
});
export default Axios



// WEBPACK FOOTER //
// ./src/providers/http-service.js